import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {template} from './template';
// imported in auth-container
// import './index.styl';

export class AuthFooter extends Component<EmptyObj> {
  static get attrsSchema() {
    return {
      'show-footer-links': `boolean`,
    };
  }
  get config() {
    return {
      template,
    };
  }
}

export const AuthFooterEl = defineAndMakeJsxFactory(`auth-footer`, AuthFooter);
